import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { AppDomain } from '@ibk/shared-types';
import { contaPjTranslations } from '../../translations';
import { AccountOpeningSteps } from '../ContaPJPromo/AccountOpeningSteps';
import { ContaPJPageLayout } from '../ContaPJPromo/ContaPJPageLayout';
import styles from '../ContaPJPromo/ContaPJPromo.module.css';
function buildNotApprovedSteps(context, t) {
    const step1 = context === AppDomain.EMPRESA
        ? {
            title: t('notApproved.steps.empresa.step1.title'),
            description: t('notApproved.steps.empresa.step1.description'),
            state: 'done',
        }
        : {
            title: t('notApproved.steps.step1.title'),
            description: t('notApproved.steps.step1.description'),
            state: 'done',
        };
    return [
        step1,
        {
            title: t('notApproved.steps.step2.title'),
            description: t('notApproved.steps.step2.description'),
            state: 'current',
        },
    ];
}
function ContaPJNotApprovedContent({ context = AppDomain.ESCRITORIO }) {
    const { t } = useTranslation();
    const steps = buildNotApprovedSteps(context, t);
    return (_jsx(ContaPJPageLayout, { context: context, dataTestId: 'conta-pj-not-approved', title: t('notApproved.title'), subtitle: t('notApproved.subtitle'), bannerAlt: t('notApproved.bannerAlt'), children: _jsxs("div", { className: `${styles.card} ${styles.cardWide}`, "data-testid": 'conta-pj-not-approved-card', children: [_jsx("h2", { className: styles.cardTitle, children: t('notApproved.cardTitle') }), _jsx(AccountOpeningSteps, { steps: steps, dataTestId: 'conta-pj-not-approved-steps' })] }) }));
}
export function ContaPJNotApproved({ context = AppDomain.ESCRITORIO }) {
    return (_jsx(TranslationProvider, { translations: contaPjTranslations, defaultLanguage: 'pt-BR', children: _jsx(ContaPJNotApprovedContent, { context: context }) }));
}
